// Mode values for allowed-types context (standard, id documents, image-only).
export const ALLOWED_TYPES_MODE_STANDARD = 'standard';
export const ALLOWED_TYPES_MODE_ID = 'id';
export const ALLOWED_TYPES_MODE_IMAGE_ONLY = 'imageOnly';

// ID type code for visa documents.
export const VISA_DOCUMENT_ID_TYPE = 'visa_document';

// MIME lists: full standard list, then restricted/extra variants.
export const ALLOWED_UPLOAD_MIME_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
  'image/svg+xml',
  'image/svg xml',
  'image/avif',
];

export const ALLOWED_ID_MIME_TYPES = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];

export const ALLOWED_VISA_DOCUMENT_EXTRA_MIME_TYPES = ['text/html'];

export const ALLOWED_IMAGE_ONLY_MIME_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
  'image/svg+xml',
  'image/svg xml',
  'image/avif',
];
